module.exports = {
	"absenteeBids": "Absentee Bids",
	"biddingNotPossible": "Bidding is not possible on that auction.",
	"header": "Dashboard",
	"maximumUpTo": "You have set a maximum of up to: __maximum__",
	"noAbsenteeBids": "You don't have any absentee bids.",
	"noBids": "You don't have any bids.",
	"noInformationOnAuction": "No information regarding the state of this auction is available.",
	"noMaximumBid": "You did not set a maximum bid.",
	"notWatchingAnyAuction": "Not watching any auction.",
	"notWatchingAnyLots": "Not watching any lots.",
	"silentBid": "This is a silent bid.",
	"watchedAuctions": "Watched Auctions",
	"watchedLots": "Watched Lots",
	"bids": "Bids",
	"wonLot": "You have won this lot.",
	"lostLot": "You have lost this lot.",
	"cancelledLot": "This lot has been cancelled."
}


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@auex/locales/lib/en/dashboard.json5
// module id = 1926
// module chunks = 6